<template>
  <div v-if="code">
    {{ code }}
    <mt-button @click="copyItem({ code }, $event)">复制</mt-button>
  </div>
</template>

<script>
import copyText from '@/utils/clipboard'
import { pageArgs } from '@/utils';
export default {
  name: 'userinfo-copycode',
  data() {
    const { getcode_test: code } = pageArgs.args()
    return { code }
  },
  methods: {
    copyItem({ code }, $event) {
      const text = `${code}`
      copyText(text, $event)
    }
  }
}
</script>

<style>

</style>